import React from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import Sidebar from '../../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../../assests/leftArrow.svg";
import BulkQRCodeGenerator from '../BulkQRCodeGenerator';
import moment from 'moment-timezone';
import "./ListOfCreatedUid.css"

const ListOfCreatedUid = ({ 
  createdUids, 
  onBack, 
  onStartPDFDownload,
  pdfDownloading,
  onPDFDownloadComplete 
}) => {

  // Format date using Moment.js (UTC to IST)
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      // Convert UTC to IST and format
      return moment.utc(dateString).tz('Asia/Kolkata').format('DD/MM/YYYY, hh:mm:ss A');
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'N/A';
    }
  };

  // Get status display value
  const getStatusDisplay = (status) => {
    if (status === "1" || status === 1 || status === "Active") {
      return "Active";
    } else if (status === "0" || status === 0 || status === "Inactive") {
      return "Inactive";
    }
    return status || "Active";
  };

  return (
    <div className="list-created-uids-container">
      {/* Sidebar - Conditionally render if needed */}
      <Sidebar />
      
      {/* Main Content */}
      <div className="list-created-main-content">
        {/* Header Section */}
        <div className="list-created-header-section">
          <Button
            className="list-created-back-button"
            onClick={onBack}
            aria-label="Go back"
          >
            <img src={leftArrow} alt="Back" />
          </Button>
          <h1 className="list-created-main-title">Created UIDs List</h1>
        </div>

       
        {/* UIDs Table */}
        <div className="list-created-table-section">
          <TableContainer component={Paper} className="list-created-table-container">
            <Table className="list-created-table">
              <TableHead>
                <TableRow>
                  <TableCell className="list-created-table-header">S.No.</TableCell>
                  <TableCell className="list-created-table-header">UID</TableCell>
                  <TableCell className="list-created-table-header">Status</TableCell>
                  <TableCell className="list-created-table-header">Admin Name</TableCell>
                  <TableCell className="list-created-table-header">Mapping State</TableCell>
                  <TableCell className="list-created-table-header">Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {createdUids.map((uid, index) => (
                  <TableRow key={uid.uid || index} className="list-created-table-row">
                    <TableCell className="list-created-table-cell">{index + 1}</TableCell>
                    <TableCell className="list-created-table-cell uid-cell">{uid.uid}</TableCell>
                    <TableCell className="list-created-table-cell">
                      <span className={`status-badge status-${getStatusDisplay(uid.status)?.toLowerCase() || 'active'}`}>
                        {getStatusDisplay(uid.status)}
                      </span>
                    </TableCell>
                    <TableCell className="list-created-table-cell">{uid.createdByName || 'N/A'}</TableCell>
                    <TableCell className="list-created-table-cell">
                      <span className={`mapping-badge mapping-${uid.mappingState?.toLowerCase() || 'unmapped'}`}>
                        {uid.mappingState || 'Unmapped'}
                      </span>
                    </TableCell>
                    <TableCell className="list-created-table-cell">
                      {formatDate(uid.createdAt)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

       
        <BulkQRCodeGenerator
          open={pdfDownloading}
          onClose={() => {}}
          uids={createdUids}
          pdfDownloading={pdfDownloading}
          onPDFDownloadComplete={onPDFDownloadComplete}
        />

        
      </div>
    </div>
  );
};

export default ListOfCreatedUid;